import React from 'react';
import SubApplicationTable from './subapplicationTable';
import {safeAddNoFixed} from 'common/utils';
import {
  get,
  find,
  reduce,
  isEqual,
  map,
  filter,
  first,
  forEach,
  isArray,
  sortBy,
} from 'lodash';
import {SUBAPPLICATION_PATHS} from './constants';

export default class SubApplicationsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rankDisplayError: false,
      errorMessages: '',
      results: [],
    };
  }

  componentDidUpdate(prevProps) {
    const propsEntityIds = map(this.props.results, 'entityId');
    const stateEntityIds = map(this.state.results, 'entityId');
    if (
      !isEqual(get(this.props, 'results'), get(prevProps, 'results')) ||
      !isEqual(propsEntityIds, stateEntityIds)
    ) {
      const {results} = this.props;
      if (isArray(results)) {
        const resultsWithIds = map(results, (result, index) => {
          return {
            id: index,
            entityId: result.entityId,
            subApplicationCategory: get(result, SUBAPPLICATION_PATHS.subAppCategory),
          };
        });
        this.setState({
          results: resultsWithIds,
          errors: {},
        });
      }
    }
  }

  organizeFundingCategoryList = () => {
    const subApps = this.props.readOnly
      ? sortBy(this.props.results, ({payload}) => payload.rank)
      : this.props.results;
    return reduce(
      this.props.categoryOptions,
      (acc, option) => {
        const results = filter(subApps, ({payload}) => {
          return get(payload, 'subApplicationCategory') === option.text;
        });
        if (results.length === 0) {
          return acc;
        }
        acc.push({
          title: get(first(results), 'payload.subApplicationCategory'),
          results,
        });
        return acc;
      },
      []
    );
  };

  render() {
    const {
      columns,
      options,
      categoryOptions,
      categoryLabel,
      readOnly,
      errors,
      handleCardDelete,
      handleChange,
      handleValidateAndSaveRank,
      applicationStatus,
    } = this.props;
    const {results: cbResults} = this.state;

    const calcTotal = (items) => {
      const currencyColumn = find(
        this.props.columns,
        (column) => column.type === 'currency'
      );
      let total = 0;
      if (currencyColumn) {
        forEach(items, (item) => {
          if (get(item, currencyColumn.key)) {
            total = safeAddNoFixed(total, get(item, currencyColumn.key, []));
          }
        });
      }
      return total;
    };

    const subApplicationTables = this.organizeFundingCategoryList();

    return (
      <React.Fragment>
        {map(subApplicationTables, ({title, results}) => {
          const filteredColumns = filter(
            columns,
            ({excludes = []}) => !excludes.includes(title)
          );

          const filteredColumnsForStatuses = filter(
            filteredColumns,
            ({showOnStatuses = []}) =>
              showOnStatuses.length === 0 || showOnStatuses.includes(applicationStatus)
          );

          return (
            <SubApplicationTable
              {...{
                title,
                results,
                totalAmount: calcTotal(results),
                columns: filteredColumnsForStatuses,
                cbResults: filter(
                  cbResults,
                  (row) => row.subApplicationCategory === title
                ),
                readOnly,
                categoryLabel,
                options,
                errors,
                categoryOptions,
              }}
              handleCardDelete={handleCardDelete}
              handleChange={handleChange}
              handleSave={this.props.handleSave}
              handleValidateAndSaveRank={handleValidateAndSaveRank}
            />
          );
        })}
      </React.Fragment>
    );
  }
}
